import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          setError("No session ID found");
          setTimeout(() => navigate('/advisor/login'), 2000);
          return;
        }

        // Send session_id to backend
        const response = await fetch(`${API_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId })
        });

        const data = await response.json();

        if (!response.ok) {
          setError(data.detail || "Authentication failed");
          setTimeout(() => navigate('/advisor/login'), 3000);
          return;
        }

        // Clear the URL hash
        window.history.replaceState(null, '', window.location.pathname);

        // Check if profile is complete or new user
        if (data.is_new_user || !data.user?.profile_completed) {
          // Navigate to profile setup with user data
          navigate('/advisor/setup', { state: { user: data.user } });
        } else {
          // Navigate to dashboard with user data
          navigate('/advisor/dashboard', { state: { user: data.user } });
        }

      } catch (err) {
        console.error("Auth error:", err);
        setError("Authentication failed. Please try again.");
        setTimeout(() => navigate('/advisor/login'), 3000);
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFFFFF] to-[#EDF1F8] flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <div className="text-red-600">
            <p className="text-xl mb-2">{error}</p>
            <p className="text-[#3A4557]">Redirecting to login...</p>
          </div>
        ) : (
          <>
            <Loader2 className="h-12 w-12 text-[#A87608] animate-spin mx-auto mb-4" />
            <p className="text-[#1B2A4A] text-xl">Signing you in...</p>
            <p className="text-[#3A4557] mt-2">Please wait</p>
          </>
        )}
      </div>
    </div>
  );
}
